import React from 'react';
import { View, Text, Link } from '@react-pdf/renderer';
import { cvStyles } from '../cvStyles';
import { formatDate } from '../../hooks/useProjects';
import { cvConfig } from '../cvConfig';

/**
 * Componente de Proyectos del CV
 * Muestra los proyectos destacados con enlaces a repositorios
 */
export const CVProjects = ({ projects }) => {
  if (!projects || projects.length === 0) return null;

  // Limitar cantidad de proyectos según configuración
  const limitedProjects = projects.slice(0, cvConfig.limits.maxProjects);

  return (
    <View style={cvStyles.section} wrap={false}>
      <Text style={cvStyles.sectionTitle}>Proyectos Destacados</Text>
      
      {limitedProjects.map((project, index) => {
        return (
          <View key={index} style={cvStyles.projectItem}>
            {/* Header del proyecto */}
            <View style={cvStyles.projectHeader}>
              <Text style={cvStyles.projectTitle}>{project.title}</Text>
              {project.date && (
                <Text style={cvStyles.projectDate}>
                  {formatDate(project.date)}
                </Text>
              )}
            </View>

            {/* Descripción */}
            {project.description && (
              <Text style={cvStyles.projectDescription}>
                {project.description}
              </Text>
            )}

            {/* Enlaces directos */}
            {project.repository && (
              <View style={{ marginTop: 6, marginBottom: 4 }}>
                <Text style={{ 
                  fontSize: cvConfig.fonts.size.small,
                  color: cvConfig.colors.secondary,
                  fontFamily: cvConfig.fonts.bold
                }}>
                  Código:{' '}
                  <Link 
                    src={project.repository}
                    style={{ 
                      color: cvConfig.colors.primary,
                      textDecoration: 'underline',
                      fontFamily: cvConfig.fonts.main
                    }}
                  >
                    {project.repository}
                  </Link>
                </Text>
              </View>
            )}

            {project.demo && (
              <View style={{ marginBottom: 6 }}>
                <Text style={{ 
                  fontSize: cvConfig.fonts.size.small,
                  color: cvConfig.colors.secondary,
                  fontFamily: cvConfig.fonts.bold
                }}>
                  Demo:{' '}
                  <Link 
                    src={project.demo}
                    style={{ 
                      color: cvConfig.colors.primary,
                      textDecoration: 'underline',
                      fontFamily: cvConfig.fonts.main
                    }}
                  >
                    {project.demo}
                  </Link>
                </Text>
              </View>
            )}

            {/* Tecnologías */}
            {project.technologies && project.technologies.length > 0 && (
              <View style={cvStyles.projectTechnologies}>
                {project.technologies.map((tech, techIndex) => (
                  <Text key={techIndex} style={cvStyles.technologyTag}>
                    {tech}
                  </Text>
                ))}
              </View>
            )}
          </View>
        );
      })}
    </View>
  );
};
